import type { ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { APP_VERSION } from '@sincronia/shared';
import { BrandMark, Wordmark } from '../components/Brand.js';
import { Button } from '../components/ui.js';
import { useT } from '../i18n/index.js';
import { unlockAudio } from '../lib/feedback.js';

export function HomePage(): ReactNode {
  const t = useT();
  const navigate = useNavigate();

  const go = (path: string) => (): void => {
    unlockAudio();
    void navigate(path);
  };

  return (
    <main className="safe-x safe-bottom safe-top mx-auto flex w-full max-w-md flex-1 flex-col items-center justify-center gap-10 px-5 py-10">
      <header className="flex flex-col items-center gap-4 text-center">
        <BrandMark size={92} />
        <h1 className="text-5xl font-semibold tracking-tight">
          <Wordmark />
        </h1>
        <p className="text-balance text-lg text-night-300">{t('app.tagline')}</p>
        <p className="text-balance text-sm text-night-400">{t('home.intro')}</p>
      </header>

      <div className="flex w-full flex-col gap-3">
        <Button variant="primary" fullWidth onClick={go('/criar')} data-testid="home-create">
          {t('home.create')}
        </Button>
        <Button variant="secondary" fullWidth onClick={go('/entrar')} data-testid="home-join">
          {t('home.join')}
        </Button>
      </div>

      <footer className="flex flex-col items-center gap-2 text-center">
        <Link to="/como-jogar" className="text-sm text-pulse-400 underline underline-offset-4">
          {t('home.howToPlay')}
        </Link>
        <p className="text-xs text-night-400" data-testid="app-version">
          {t('app.version', { version: APP_VERSION })}
        </p>
      </footer>
    </main>
  );
}
